import { CustomerFeedbackStatistics } from "../../../models/Statistics";

export const REQUEST_CUSTOMERFEEDBACKSTATISTICS =
  "REQUEST_CUSTOMERFEEDBACKSTATISTICS";
export const REQUEST_CUSTOMERFEEDBACKSTATISTICS_DONE =
  "REQUEST_CUSTOMERFEEDBACKSTATISTICS_DONE";

export interface FetchCustomerFeedbackStatistics {
  type: typeof REQUEST_CUSTOMERFEEDBACKSTATISTICS;
  payload: ReadonlyArray<CustomerFeedbackStatistics>;
}

export interface FetchCustomerFeedbackStatisticsDone {
  type: typeof REQUEST_CUSTOMERFEEDBACKSTATISTICS_DONE;
  payload: ReadonlyArray<CustomerFeedbackStatistics>;
}

export interface CustomerFeedbacksStatisticsState {
  isLoading: boolean;
  customerFeedbackStatistics: ReadonlyArray<CustomerFeedbackStatistics>;
}

export type CustomerFeedbackStatisticsActions =
  | FetchCustomerFeedbackStatistics
  | FetchCustomerFeedbackStatisticsDone;
